// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.-layout-h {
  display: flex;
  flex-direction: row;
}

.-layout-h-reverse {
  display: flex;
  flex-direction: row-reverse;
}

.-layout-v {
  display: flex;
  flex-direction: column;
}

.-layout-v-reverse {
  display: flex;
  flex-direction: column-reverse;
}

/* alignment in cross axis */
.-start,
.-align-start {
  align-items: flex-start;
}

.-center,
.-center-center {
  align-items: center;
}

.-end,
.-align-end {
  align-items: flex-end;
}

.-stretch,
.-align-stretch {
  align-items: stretch;
}

/* alignment in main axis */
.-justify-start {
  justify-content: flex-start;
}

.-justify-center,
.-center-center {
  justify-content: center;
}

.-justify-end {
  justify-content: flex-end;
}

.-justify-around {
  justify-content: space-around;
}

.-justify,
.-justify-between {
  justify-content: space-between;
}

.-justify-evenly {
  justify-content: space-evenly;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA,4BAA4B;AAC5B;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA,2BAA2B;AAC3B;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.-layout-h {\n  display: flex;\n  flex-direction: row;\n}\n\n.-layout-h-reverse {\n  display: flex;\n  flex-direction: row-reverse;\n}\n\n.-layout-v {\n  display: flex;\n  flex-direction: column;\n}\n\n.-layout-v-reverse {\n  display: flex;\n  flex-direction: column-reverse;\n}\n\n/* alignment in cross axis */\n.-start,\n.-align-start {\n  align-items: flex-start;\n}\n\n.-center,\n.-center-center {\n  align-items: center;\n}\n\n.-end,\n.-align-end {\n  align-items: flex-end;\n}\n\n.-stretch,\n.-align-stretch {\n  align-items: stretch;\n}\n\n/* alignment in main axis */\n.-justify-start {\n  justify-content: flex-start;\n}\n\n.-justify-center,\n.-center-center {\n  justify-content: center;\n}\n\n.-justify-end {\n  justify-content: flex-end;\n}\n\n.-justify-around {\n  justify-content: space-around;\n}\n\n.-justify,\n.-justify-between {\n  justify-content: space-between;\n}\n\n.-justify-evenly {\n  justify-content: space-evenly;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
